/* eslint-disable */

const state = {
  closeApp: false
}

const mutations = {
  SET_CLOSE_APP: (state, isClosed) => {
    state.closeApp = isClosed
  }
}

const actions = {
  // remove token
  updateCloseApp({ commit }, isClosed) {
    return new Promise(resolve => {
      commit('SET_CLOSE_APP', isClosed)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/utilsCordova.js